import { render, staticRenderFns } from "./ConfiguracoesPorMarca.vue?vue&type=template&id=ee1e14ea&scoped=true&"
import script from "./ConfiguracoesPorMarca.vue?vue&type=script&lang=js&"
export * from "./ConfiguracoesPorMarca.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracoesPorMarca.vue?vue&type=style&index=0&id=ee1e14ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1e14ea",
  null
  
)

export default component.exports